import { render, staticRenderFns } from "./MobileMenuSubmenuItem.vue?vue&type=template&id=1ea48167&scoped=true&"
import script from "./MobileMenuSubmenuItem.vue?vue&type=script&lang=ts&"
export * from "./MobileMenuSubmenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./MobileMenuSubmenuItem.vue?vue&type=style&index=0&id=1ea48167&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea48167",
  null
  
)

export default component.exports